// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2925f8a0","854":"3c2fa9da"}[chunkId] + ".chunk.js";
};